export default __webpack_public_path__ + "static/media/cases4.fd43501f.jpg";